import { PairedCostAdjustmentSummaryTableRow } from './PairedCostAdjustmentSummaryTableRow.js';
import { PairedCostAdjustmentSummaryProps } from './types.js';

export const PairedCostAdjustmentSummaryTableSiteRows = (
  props: PairedCostAdjustmentSummaryProps,
) => (
  <>
    {props.isSimplifiedMode ? (
      <>
        <PairedCostAdjustmentSummaryTableRow {...props} row={{ path: 'site', alwaysShow: true }} />
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{ path: 'locationView.location', alwaysShow: true }}
          rowSpan={props.isSimplifiedMode ? 2 : 1}
        />
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{ path: 'locationView.view', alwaysShow: true }}
          includeAdjustmentCell={false}
        />
      </>
    ) : (
      <>
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{ path: 'site.size', alwaysShow: true }}
          rowSpan={props.isSimplifiedMode ? 1 : 3}
        />
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{ path: 'site.location', alwaysShow: true, suppressDetails: true }}
          includeAdjustmentCell={false}
        />
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{ path: 'site.view', alwaysShow: true, suppressDetails: true }}
          includeAdjustmentCell={false}
        />
      </>
    )}
  </>
);
